module.exports = __webpack_public_path__ + "img/introduction-hascar.a6ce5ac5.jpg";